export default {"src":"/_next/static/media/alert.d67159fa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};